import { notification } from 'antd'

export const MAX_FILE_SIZE_MB = 2

const BYTES_PER_MB = 1024 * 1024

export const isFileTooLarge = file => file.size > MAX_FILE_SIZE_MB * BYTES_PER_MB

export const getFileTooLargeDescription = (file, t) => t('file_too_large_message.description', {
  name: file.name,
  size: (file.size / BYTES_PER_MB).toLocaleString(undefined, { maximumFractionDigits: 2 }),
  max: MAX_FILE_SIZE_MB
})

export const notifyFileTooLarge = (file, t) => {
  notification.error({
    message: t('file_too_large_message.title'),
    description: getFileTooLargeDescription(file, t),
    placement: 'bottomRight'
  })
}
